import React, { useState, useEffect } from 'react';

const InquiryList = () => {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState('All');

  useEffect(() => {
    const fetchInquiries = async () => {
      try {
        const response = await fetch('https://growhomestudio.onrender.com/api/inquiries');
        const data = await response.json();
        setInquiries(data);
      } catch (err) {
        console.error('Error fetching inquiries:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchInquiries();
  }, []);

  const updateStatus = async (id, newStatus) => {
    try {
      const response = await fetch(`https://growhomestudio.onrender.com/api/inquiries/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ status: newStatus }),
      });

      if (response.ok) {
        const updatedInquiry = await response.json();
        setInquiries((prevInquiries) =>
          prevInquiries.map((inquiry) =>
            inquiry._id === id ? { ...inquiry, status: updatedInquiry.status } : inquiry
          )
        );
      }
    } catch (err) {
      console.error('Error updating status:', err);
    }
  };

  const handleFilterChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  const filteredInquiries = selectedStatus === 'All'
    ? inquiries
    : inquiries.filter((inquiry) => inquiry.status === selectedStatus);

  if (loading) {
    return <div>Loading inquiries...</div>;
  }

  return (
    <div className="bg-white p-4 rounded shadow-md">
      {/* Status filter dropdown */}
      <div className="mb-4">
        <label htmlFor="statusFilter" className="block text-sm font-medium mb-2">
          Filter by Status
        </label>
        <select
          id="statusFilter"
          value={selectedStatus}
          onChange={handleFilterChange}
          className="w-full px-4 py-2 border rounded"
        >
          <option value="All">All</option>
          <option value="New">New</option>
          <option value="In Progress">In Progress</option>
          <option value="Delivered">Delivered</option>
          <option value="Lost">Lost</option>
        </select>
      </div>

      {/* Inquiries table */}
      <table className="w-full text-left border-collapse">
        <thead>
          <tr>
            <th className="border p-2">Name</th>
            <th className="border p-2">Mobile</th>
            <th className="border p-2">Status</th>
            <th className="border p-2">Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredInquiries.map((inq) => (
            <tr key={inq._id}>
              <td className="border p-2">{inq.name}</td>
              <td className="border p-2">{inq.mobile}</td>
              <td className="border p-2">{inq.status}</td>
              <td className="border p-2">
                {/* In Progress button */}
                <button
                  className="bg-blue-500 text-white px-3 py-1 rounded mr-2"
                  onClick={() => updateStatus(inq._id, 'In Progress')}
                  disabled={inq.status !== 'New'}
                >
                  In Progress
                </button>

                {/* Mark Complete button */}
                <button
                  className="bg-green-500 text-white px-3 py-1 rounded mr-2"
                  onClick={() => updateStatus(inq._id, 'Delivered')}
                  disabled={inq.status !== 'In Progress'}
                >
                  Mark Complete
                </button>

                {/* Lost Client button */}
                <button
                  className="bg-red-500 text-white px-3 py-1 rounded"
                  onClick={() => updateStatus(inq._id, 'Lost')}
                  disabled={inq.status === 'Delivered'}
                >
                  Lost Client
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InquiryList;
